<script>

  import {calcPercent, ignore, parseNumber} from '../../../Common/tools';
  import {External, M} from '../../../external';
  import {onMount} from 'svelte';
  import {validateSMSMessage} from '../../../CRM/Popups/messages/common';
  import SMSEditor from "../../../CRM/Popups/messages/SMSEditor.svelte";
  import {getAutomationSalesTotals, viewFullAnalytics} from "../../static";
  import {EMPTY_SALES_TOTALS, getSalesCountLabel} from "../../../Store/static";

  export let data = {}, automation, onChange = ignore, valid, error;

  let message;
  let salesUtm = null, salesTotals = EMPTY_SALES_TOTALS;

  if (!data.settings) {
    data.settings = [];
  }

  if(data.settings[0]) {
    message = JSON.parse(data.settings[0].value);
  }

  if(data.settings[1]) {
    salesUtm = JSON.parse(data.settings[1].value)
  }

  function updateMessage(message) {
    try {
      valid = validateSMSMessage(message);
    } catch (e) {
      error = e;
      valid = false;
      return;
    }

    data.settings[0] = {
      key: '0',
      value: JSON.stringify(message)
    };

    data.name = message.body;
    if (data.name.length > 30) {
      data.name = data.name.substring(0, 30) + "...";
    }
    data.name = '"' + data.name + '"';

    onChange();
  }

  function updateSalesUtm() {
    valid = !salesUtm || salesUtm.campaign?.length; //campaign is mandatory if salesUtm is present/enabled

    if (!valid) {
      error = M.INVALID_UTM_CAMPAIGN;
      return;
    }

    data.settings[1] = {
      key: 'salesUtm',
      value: JSON.stringify(salesUtm)
    };

    onChange();
  }

  function enableSalesUtm() {
    salesUtm = salesUtm ? null : {};
    updateSalesUtm();
  }

  onMount(async () => {
    if (salesUtm) {
      salesTotals = await getAutomationSalesTotals(automation, salesUtm);
    }
  });

</script>

<div class='col20 f-left small-rules mb-25'>
  <h4 class='col20 f-left mt-5 mb-25 mb-15 t-center' style='line-height:1.4;'>{M.SEND_SMS}</h4>

  {#if data.id && data.completed > 0}
    <div class='chart-wrapper compact-chart-wrapper col20 f-left'>
      <div class='horizontal-chart-wrapper flex align-center'>
        <h4>{M.SENT}</h4>
        <div class='horizontal-chart-progress'>
          <div class='horizontal-chart-progress-inner' style='width:100%;'>
            <span class='chart-label'>{parseNumber(data.completed)} - 100%</span>
          </div>
        </div>
      </div>
      {#if salesUtm}
        <div class='horizontal-chart-wrapper flex align-center'>
          <h4>{M.PURCHASED}</h4>
          <div class='horizontal-chart-progress'>
            <div class='horizontal-chart-progress-inner' style={"width:" + calcPercent(salesTotals.orders, data.completed) + "; background-color: #76bd65"}>
              <span class='chart-label'>{calcPercent(salesTotals.orders, data.completed)} - {External.Tools.currencyToStrWithSymbol(salesTotals.sales)} ({getSalesCountLabel(salesTotals.orders)})</span>
            </div>
          </div>
        </div>
      {/if}
    </div>
    <div class='col20 f-left mt-5 t-center'>
      <a class='middle-button blue f-none inline-block close-popup'
         on:click={() => viewFullAnalytics(automation.id)}>{M.VIEW_FULL_ANALYTICS}</a>
    </div>
  {/if}

  <div class='col20 f-left mt-20'>
    <div class="checkbox-wrapper">
      <input id="trackSalesCheck" class="css-checkbox select-cbx" checked={salesUtm}
             type="checkbox" name="trackSalesCheck" on:change={enableSalesUtm}/>
      <label for="trackSalesCheck" class="css-label">{M.TRACK_MESSAGE_SALES}</label>
    </div>
    {#if salesUtm}
      <div class="info">
        <span class="light-gray-text">{M.SALES_TRACKING_UTM_DESC}</span>
      </div>
      <div class="popup-input-wrapper mt-15 mb-5">
        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.SOURCE}</span>
        <span class="light-gray-text" style="line-height: 1.4">{M.FB_GOOGLE_NEWSLETTER}</span>
        <input type="text" placeholder={M.SOURCE} bind:value={salesUtm.source} on:change={updateSalesUtm} class="col20 f-left clear-left" style="margin-top: 5px" />
      </div>
      <div class="popup-input-wrapper mb-5">
        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.CAMPAIGN}</span>
        <span class="light-gray-text" style="line-height: 1.4">{M.DEAL_PROMOTION}</span>
        <input type="text" placeholder={M.CAMPAIGN} bind:value={salesUtm.campaign} on:change={updateSalesUtm} class="col20 f-left clear-left" style="margin-top: 5px"/>
      </div>
      <div class="popup-input-wrapper mb-5">
        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.UTM_MEDIUM}</span>
        <span class="light-gray-text" style="line-height: 1.4">{M.SOCIAL_PPC_EMAIL}</span>
        <input type="text" placeholder={M.UTM_MEDIUM} bind:value={salesUtm.medium} on:change={updateSalesUtm} class="col20 f-left clear-left" style="margin-top: 5px"/>
      </div>
    {/if}
  </div>

  <div class='col20 f-left mt-10'>
    <SMSEditor {message} onChange={updateMessage} utm={salesUtm} />
  </div>
</div>
